import { z } from "zod";
import { AnswerSchema } from "./Answer";

export const AnswerRequestSchema = AnswerSchema.pick({
    description: true
});

export type AnswerRequest = z.infer<typeof AnswerRequestSchema>;
